<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2_text"><a id="page_19"></a>AT YOUR SERVICE</h2>
<p class="running_first">Having some basic casserole dishes on hand will speed things up:</p>
<ul>
<li><img alt="image" src="images/common.jpg"/> 2- to 4-cup ramekins for appetizers</li>
<li><img alt="image" src="images/common.jpg"/> 1-quart dishes for smaller servings</li>
<li><img alt="image" src="images/common.jpg"/> Shallow casseroles in oval, rectangular, square, and other shapes for vessel variety and visual interest</li>
<li><img alt="image" src="images/common.jpg"/> Dutch ovens with lids (averaging 3 to 6 quarts) and round soufflé dishes (at least 2 quarts)</li>
<li><img alt="image" src="images/common.jpg"/> One each of 8-by-8-inch, 9-by-9-inch, 13-by-9-inch, and 9-by-2-inch and/or 9-by-3-inch round baking dishes</li>
</ul>
<h2 class="h2_text">TOP TIPS</h2>
<ul>
<li><img alt="image" src="images/common.jpg"/> Make sure your dish is oven safe. This is very important to know before you stick it in the oven. Some artisan pans, or mass-produced dishes, if not marked “ovenproof,” will shatter when heated to certain high temperatures; they also might contain lead. Ask the craftsperson or store owner, or inspect the box closely to see if it’s safe for food and/or cooking—or if it’s purely just kitchen decoration.</li>
<li><img alt="image" src="images/common.jpg"/> For fast cleanup, grease casserole pans or dishes with nonstick cooking spray.</li>
<li><img alt="image" src="images/common.jpg"/> Avoid cooking on top and bottom oven racks. The middle of the oven is where the most even heat should be centered.</li>
<li><img alt="image" src="images/common.jpg"/> Ovens heat differently, so check for doneness about 10 minutes before the minimum cooking time.</li>
<li><img alt="image" src="images/common.jpg"/> If you use aluminum foil to cover a casserole, place the shiny side down so it retains, instead of deflecting, the heat.</li>
</ul>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_chapter01b.vue?02ea4aba